import _ from 'lodash'
import { useState } from 'react'
import { savePartnerClient } from '../fire'
import { useDeepState } from '../utils'
import api from '../api'
import NewUserEditor from './NewUserEditor'
import Tooltip from './Tooltip'
import Modal from './Modal'

// just users editable for now
let PartnerClientEditor = ({ onClose, client }) => {
  console.log({ client })
  let [saving, setSaving] = useState(false)
  let [savedClient, setSavedClient] = useState(client)
  let [addingNewUser, setAddingNewUser] = useState(false)
  let [deletingUserId, setDeletingUserId] = useState('')
  let [state, set] = useDeepState({
    users: null, // it'll be an object, not an array
    ...client,
  })
  let { name, id, users } = state
  let newClient = !savedClient

  return (
    <Modal
      isOpen
      title={newClient ? 'New Client' : 'Edit Client'}
      maxWidth="96%"
      onClose={() => onClose()}
      body={
        <div>
          <div>
            <div className="form">
              <div className="form-group">
                <div className="row">
                  <div className="col-lg-4 col-sm-6">
                    <label>Name</label>
                    <input
                      readOnly
                      className="form-control form-control-sm"
                      value={name}
                    />
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <label>ID</label>
                    <input
                      readOnly
                      className="form-control form-control-sm"
                      value={id}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Users</label>
                {_.map(users, (user, userId) =>
                  !user ? null : (
                    <div className="row mb-1 mr-0" key={userId}>
                      <div className="col pr-0">
                        <input
                          onChange={e =>
                            set(['users', userId, 'name'], e.target.value)
                          }
                          className="form-control form-control-sm"
                          placeholder="Name"
                          value={user.name}
                        />
                      </div>
                      <div className="col pr-0">
                        <input
                          className="form-control form-control-sm"
                          placeholder="Phone number"
                          onChange={e =>
                            set(
                              ['users', userId, 'phoneNumber'],
                              e.target.value
                            )
                          }
                          value={user.phoneNumber}
                        />
                      </div>
                      <div className="col pr-0">
                        <input
                          className="form-control form-control-sm"
                          readOnly
                          value={user.email}
                        />
                      </div>
                      <div
                        className="input-group ml-2"
                        style={{ width: '130px' }}
                      >
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fa fa-tag" />
                          </span>
                        </div>
                        <input
                          className="form-control form-control-sm"
                          placeholder="Tag"
                          value={user.tag || ''}
                          onChange={e =>
                            set(['users', userId, 'tag'], e.target.value)
                          }
                        />
                      </div>
                      <div className="col">
                        <Tooltip
                          title="Always include this user's email address on leads with 'sent' status"
                          style={{ display: 'inline-block' }}
                          topOffset={10}
                          wrap
                        >
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() =>
                              set(
                                ['users', userId, 'excludeFromLeadNotifyEmail'],
                                !user.excludeFromLeadNotifyEmail
                              )
                            }
                          >
                            <i className="fa fa-paper-plane" /> Include{' '}
                            <div
                              className="d-inline-block"
                              style={{ width: '25px' }}
                            >
                              {!user.excludeFromLeadNotifyEmail ? (
                                <i className="fa fa-check" />
                              ) : (
                                <i className="fa fa-remove" />
                              )}
                            </div>
                          </button>
                        </Tooltip>
                        <button
                          className="ml-2 btn btn-danger btn-sm"
                          disabled={deletingUserId === userId}
                          onClick={async () => {
                            if (
                              window.confirm(
                                'Are you sure you want to delete the user?'
                              )
                            ) {
                              setDeletingUserId(userId)
                              try {
                                await api('/delete-user', {
                                  clientId: id,
                                  uid: userId,
                                })
                                set(['users', userId], undefined)
                              } catch (e) {
                                console.error(e)
                                window.alert(e)
                              }
                              setDeletingUserId('')
                            }
                          }}
                        >
                          <i className="fa fa-remove" />
                        </button>
                      </div>
                    </div>
                  )
                )}
                {addingNewUser ? (
                  <NewUserEditor
                    clientId={id}
                    onClose={() => setAddingNewUser(false)}
                    onSavedNewUser={newUser => {
                      setAddingNewUser(false)
                      set(
                        ['users', newUser.uid],
                        _.pick(newUser, [
                          'email',
                          'name',
                          'phoneNumber',
                          'tag',
                          'excludeFromLeadNotifyEmail',
                        ])
                      )
                    }}
                  />
                ) : (
                  <div className="my-2">
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setAddingNewUser(true)}
                    >
                      <i className="fa fa-plus" /> Add User
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
      footer={() => (
        <div>
          <button
            className="btn btn-danger"
            disabled={saving}
            onClick={() => onClose()}
          >
            Cancel
          </button>
          <button
            className="ml-2 btn btn-success"
            disabled={saving || addingNewUser}
            onClick={async () => {
              setSaving(true)
              try {
                let clientForSave = {
                  ...state,
                  users: _.pickBy(state.users, u => !_.isUndefined(u)), // cuz they could be undefined when deleted, though this component doesn't allow deleting at the moment.  could be done prettier eh?
                }
                await savePartnerClient({
                  client: clientForSave,
                })
                if (newClient) {
                  setSavedClient(clientForSave)
                  setSaving(false)
                } else {
                  onClose()
                }
              } catch (e) {
                setSaving(false)
                console.log('error saving partner client user!', e)
                window.alert(e.message)
              }
            }}
          >
            Save {saving && <i className="fa fa-spinner fa-spin" />}
          </button>
        </div>
      )}
    />
  )
}

export default PartnerClientEditor
